export default __webpack_public_path__ + "static/media/bkg--interiors-3.9343cf28.jpg";